import React, { useState, useEffect } from 'react'
import { Drawer, Form, Button, Col, Row, Input, Select, DatePicker } from 'antd'
import moment from 'moment'
import Map from './CreateEnquiryMap'

const { Option } = Select
const blankEnquiery = {
  latitude: -38.2378199,
  longitude: 146.3787252,
  status: 'Enquiry',
  form_id: 'e328b1d1-cd10-46d5-87d8-ace3f02a3344',
  form_values: {
    ce91: moment().format('YYYY-MM-DD'), // Date
    '6612': '', // Name
    b89a: '', // Email
    c0bc: '', // Phone
    c2eb: { choice_values: [''] }, // BoreType
    '4aad': '', // Licence
    '85fa': '', // Depth
    ba02: '', // Address
    '29fd': '' // AdditionalInformation
  }
}

export default ({ viewEnquiry, onClose, visible, onCreate, onUpdate }) => {
  const [enquiery, setEnquiery] = useState({ ...blankEnquiery })

  useEffect(() => {
    if (viewEnquiry) setEnquiery(viewEnquiry)
    return () => setEnquiery({ ...blankEnquiery })
  }, [viewEnquiry])

  useEffect(() => {
    !visible && setEnquiery({ ...blankEnquiery })
  }, [visible])

  const updateVal = (v, l, sel) =>
    sel
      ? setEnquiery({ ...enquiery, form_values: { ...enquiery.form_values, [l]: { choice_values: [v] } } })
      : setEnquiery({ ...enquiery, form_values: { ...enquiery.form_values, [l]: v } })

  return (
    <div>
      <Drawer
        title='Create Client Enquiry'
        className='clientEnquiry'
        width={800}
        placement='right'
        onClose={() => onClose()}
        maskClosable={false}
        visible={visible}
        style={{
          height: 'calc(100% - 55px)',
          overflow: 'auto',
          paddingBottom: 53
        }}>
        <Row>
          <h4 className='enq-form-label'>Date</h4>
          <DatePicker
            style={{ width: '100%' }}
            getPopupContainer={trigger => trigger.parentNode}
            format='Do MMMM YYYY'
            value={moment(enquiery.form_values['ce91'], 'YYYY-MM-DD')}
            onChange={v => updateVal(v.format('YYYY-MM-DD'), 'ce91')}
          />
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <h4 className='enq-form-label'>Name</h4>
            <Input
              placeholder='John Smith'
              value={enquiery.form_values['6612']}
              onChange={v => updateVal(v.target.value, '6612')}
            />
          </Col>
          <Col span={8}>
            <h4 className='enq-form-label'>Email</h4>
            <Input
              placeholder='johnsmith@hotmail.com'
              value={enquiery.form_values['b89a']}
              onChange={v => updateVal(v.target.value, 'b89a')}
            />
          </Col>
          <Col span={8}>
            <h4 className='enq-form-label'>Phone Number</h4>
            <Input
              placeholder='0412 123 123'
              value={enquiery.form_values['c0bc']}
              onChange={v => updateVal(v.target.value, 'c0bc')}
            />
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <h4 className='enq-form-label'>Bore Type</h4>
            <Select
              value={enquiery.form_values['c2eb'].choice_values[0]}
              onChange={v => updateVal(v, 'c2eb', true)}
              style={{ width: '100%' }}>
              <Option value='S&D'>S&D</Option>
              <Option value='Irrigation'>Irrigation</Option>
              <Option value='Coring'>Coring</Option>
            </Select>
          </Col>
          <Col span={8}>
            <h4 className='enq-form-label'>Bore Construction Liscence</h4>
            <Select value={enquiery.form_values['4aad']} onChange={v => updateVal(v, '4aad')} style={{ width: '100%' }}>
              <Option value='yes'>Yes</Option>
              <Option value='no'>No</Option>
            </Select>
          </Col>
          <Col span={8}>
            <h4 className='enq-form-label'>Approximate Depth</h4>
            <Input.TextArea
              rows={1}
              value={enquiery.form_values['85fa']}
              onChange={v => updateVal(v.target.value, '85fa')}
            />
          </Col>
        </Row>
        <Row>
          <h4 className='enq-form-label'>Address</h4>
          <Input.TextArea
            rows={1}
            value={enquiery.form_values['ba02']}
            onChange={v => updateVal(v.target.value, 'ba02')}
            style={{ marginBottom: 20 }}
          />
        </Row>
        <Row>
          <Map
            googleMapURL='https://maps.googleapis.com/maps/api/js?key=AIzaSyALSdb8pDixxuFtKtAHTfss_cW7bvI6IOY&v=3.exp&libraries=geometry,drawing,places'
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={
              <div
                style={{
                  height: `350px`,
                  border: '1px solid #e8e8e8',
                  borderRadius: '4px',
                  marginBottom: '15px'
                }}
              />
            }
            mapElement={<div style={{ height: `100%` }} />}
            placedMarker={
              enquiery.latitude
                ? [{ latitude: enquiery.latitude, longitude: enquiery.longitude, id: 0 }]
                : [{ latitude: -38.2378199, longitude: 146.3787252, id: 0 }]
            }
            getLocation={(lat, lng) => setEnquiery({ ...enquiery, latitude: lat, longitude: lng })}
          />
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Input disabled size='small' addonBefore='Lat' value={enquiery.latitude} />
          </Col>
          <Col span={12}>
            <Input disabled size='small' addonBefore='Lng' value={enquiery.longitude} />
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <h4 className='enq-form-label'>Comments</h4>
            <Input.TextArea
              rows={4}
              value={enquiery.form_values['29fd']}
              onChange={v => updateVal(v.target.value, '29fd')}
              style={{ marginBottom: 50 }}
            />
          </Col>
        </Row>

        <div
          style={{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e8e8e8',
            padding: '10px 16px',
            textAlign: 'right',
            left: 0,
            background: '#fff',
            borderRadius: '0 0 4px 4px'
          }}>
          <Button style={{ marginRight: 8 }} onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={() => (viewEnquiry ? onUpdate(enquiery) : onCreate(enquiery))} ghost type='primary'>
            {viewEnquiry ? 'Update' : 'Create'}
          </Button>
        </div>
      </Drawer>
    </div>
  )
}
